import {
  BaseUniDriver,
  UniDriver,
} from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export interface BoxUniDriver extends BaseUniDriver {}

export const boxDriverFactory = (base: UniDriver): BoxUniDriver => {
  return {
    ...baseUniDriverFactory(base),
  };
};
